import React from "react";
import { Menu, X } from "lucide-react";

const FloatingMenuButton = ({ isOpen, setIsOpen }) => {
  return (
    <button
      onClick={() => setIsOpen(!isOpen)}
      className="fixed bottom-6 right-6 w-14 h-14 bg-blue-500 rounded-full flex items-center justify-center shadow-lg z-50 lg:hidden transform transition-transform duration-200 hover:scale-110"
      style={{ zIndex: 9999 }}
    >
      {isOpen ? (
        <X color="#ffffff" size={24} />
      ) : (
        <Menu color="#ffffff" size={24} />
      )}
    </button>
  );
};

export default FloatingMenuButton; 